
// import { ref, watch } from 'vue'
import { ref, defineComponent } from 'vue'
import { useRoute } from 'vue-router'

import SocialButtons from '@/components/block/SocialButtons.vue'
// import MagazinesMatchingContent from '@/components/block/MagazinesMatchingContent.vue'

import { axiosSetting } from '@/utils/axiosSetting'

import '@/styles/wp-content.scss'
import '@/styles/matching-content.scss'

export default defineComponent({
  name: 'MagazinesMatchingDetail',
  components: {
    SocialButtons
    // MagazinesMatchingContent
  },
  beforeRouteEnter: async (to: any) => {
    const ajax = axiosSetting('cms', 'block')

    const data = await ajax
      .get(
        `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/pages?slug=${to.params.slug}`
      )
      .then((res) => {
        // return res.data
        return res.data[0]
      })

    // to.meta.breadCrumb.splice(1)

    to.meta.breadCrumb.push({ label: data.title.rendered })
    document.title = `${data.title.rendered} | ${document.title}`
  },
  setup() {
    const page = ref([])
    const route = useRoute()
    const ajax = axiosSetting('cms', 'block')

    const getPage = () => {
      ajax
        .get(
          `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/pages?slug=${route.params.slug}`
        )
        .then((res) => {
          // page.value = res.data
          page.value = res.data[0]
        })
    }

    const formatDate = (date: string) => {
      const dt = new Date(date)
      const year = dt.getFullYear()
      const month = dt.getMonth() + 1
      const day = dt.getDate()

      return `${year}年${month}月${day}日`
    }

    getPage()

    // watch(
    //   () => route.params.slug,
    //   () => {
    //     getPage()
    //   }
    // )

    return {
      page,
      formatDate
    }
  }
})
